import { render, staticRenderFns } from "./PortCallsTable.vue?vue&type=template&id=17d3c620&scoped=true&"
import script from "./PortCallsTable.vue?vue&type=script&lang=js&"
export * from "./PortCallsTable.vue?vue&type=script&lang=js&"
import style0 from "./PortCallsTable.vue?vue&type=style&index=0&id=17d3c620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d3c620",
  null
  
)

export default component.exports